import React from "react";
import "./Header.css";
import logo from "../../assets/images/Bearbitz logo.png";
import brochure from "../../assets/document/bearbitz.pdf";
import { FaDownload } from "react-icons/fa";
import { Helmet } from "react-helmet-async";

export default function Header() {
  return (
    <>
      <Helmet>
        {/* SEO */}
        <title>
          BearBitz – Premium Biscuits & Cookies Portfolio | Global Food
          Manufacturing Brand
        </title>
        <meta
          name="description"
          content="Discover BearBitz, a global brand showcasing premium biscuits, cookies, crackers, and wafers. Explore our quality products crafted for food manufacturing excellence."
        />
        <meta
          name="keywords"
          content="BearBitz, biscuits, cookies, wafers, crackers, butter cookies, cream biscuits, food manufacturing, biscuit portfolio, global biscuit brand, premium biscuits, bakery products"
        />

        {/* Facebook */}
        <meta
          property="og:title"
          content="BearBitz – Premium Biscuits & Cookies Portfolio | Global Food Manufacturing Brand"
        />
        <meta
          property="og:description"
          content="Explore BearBitz — a global brand offering premium biscuits, cookies, crackers, and wafers crafted with excellence for the food manufacturing industry."
        />
        <meta property="og:image" content="./logo192.png" />
        <meta property="og:url" content="https://www.bearbitz.in/" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="BearBitz – Premium Biscuits & Cookies Portfolio"
        />
        <meta
          name="twitter:description"
          content="BearBitz presents a premium collection of biscuits, cookies, crackers, and wafers for the global food industry."
        />
        <meta name="twitter:image" content="./logo192.png" />
      </Helmet>

      <header className="header">
        <div className="content">
          <div className="header-content">
            <div className="logo">
              <a href="/">
                <img
                  src={logo}
                  alt="BearBitz Logo"
                  className="header-logo"
                  loading="lazy"
                />
              </a>
            </div>
            <div className="download-btn">
              <a
                href={brochure}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-d">
                Download Brochure
              </a>
              <a
                href={brochure}
                download
                className="btn-m"
                aria-label="Download brochure PDF">
                <FaDownload />
              </a>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
